<template>
  <div v-if="valueModel" class="form-floating" style="border-color: #86868b;" :class="{'is-invalid': errorMessage,'has-validation': errorMessage}">
    <vue-tel-input
      v-model="valueModel.value"
      @on-input="updateValue"
      @blur="blur"
      :mode="props.mode"
      :ignoredCountries="['ps']"
      :inputOptions="inputOptions"
      :dropdownOptions="dropdownOptions"
      :preferredCountries="['fr','il','us','gb']"
      :onlyCountries="['fr','il','us','gb','ca','ie','be','gf','de','gr','gp','it','lu','mc','pl','pt','re','mf','es','se','ch']"
      :validCharactersOnly="true"
      class="border rounded"
      :class="[errorMessage ? 'is-invalid border-danger' : '']"
      style="padding-top: 1.3rem;padding-bottom: 0"
      @change="emit('change')"
    />
    <label v-if="props.label" :for="'phone-input-' + $.uid" style="color: #86868b; transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);">{{ props.label }} {{ props.required ? '*' : '' }}</label>
    <div class="invalid-feedback">{{ errorMessage }}</div>
  </div>
</template>

<script setup lang="ts">
import { useField } from 'vee-validate';
import { computed } from 'vue';
import {VueTelInput, type PhoneObject } from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';

const model = defineModel<string>({required: false});
const isValid = defineModel<boolean>('is-valid',{required: false, default: true});
const emit = defineEmits(['change'])
const props = withDefaults(defineProps<{
  valueKey?: AllTypeKeys;
  label: string;
  subLabel?: string;
  placeholder?: string;
  required?: boolean;
  mode?: 'national' | 'international';
}>(), {
  placeholder: '',
  required: false,
  mode: 'national'
});

const inputOptions = computed(() => ({
  // placeholder: props.placeholder,
  required: props.required,
  showDialCode: false,
}));

const dropdownOptions = computed(() => ({
  showDialCodeInList: false,
  showFlags:true
}));

let _isValid = true;
let newValue = '';
const updateValue = (number: string, phoneObject: PhoneObject) => {
  newValue = phoneObject?.valid && phoneObject.formatted ? phoneObject.formatted : ''
  _isValid = (number == '' && !props.required) || (phoneObject?.valid === true);
  if(_isValid) blur()
};

const blur = () => {
  isValid.value = _isValid
  if (props.valueKey && value) {
    value.value = newValue;
  } else if (model.value !== undefined) {
    model.value = newValue;
  }
};

const { value, errorMessage } = props.valueKey !== undefined ? useField<string>(() => props.valueKey!) : {};

const valueModel = computed(() => {
  if(props.valueKey) return value;
  else if(model.value !== undefined) return model;
  else return undefined;
})

</script>
